import { getCookie, removeCookie, setCookie } from 'typescript-cookie';
import { ESession } from '../enums/auth.enum';

interface IAuthCookies {
    token: string;
    userID: string;
}

export const setAuthCookies = ({ token, userID }: IAuthCookies) => {
    setCookie(ESession.JWT, token);
    setCookie(ESession.USER, userID);
};

export const setAuthCookie = (key: string, value: string | boolean) => {
    setCookie(key, value);
};

export const getAuthCookie = (key: string) => getCookie(key);

export const getAuthCookies = () => ({
    token: getCookie(ESession.JWT),
    userID: getCookie(ESession.USER),
    mustAnswerQuestion: getCookie(ESession.MUST_ANSWER_QUESTION),
});

export const removeAllCookies = () => {
    removeCookie(ESession.JWT);
    removeCookie(ESession.USER);
    removeCookie(ESession.WORKSPACE);
};
